export const slots = {
  batteries: [
    { latitude: 41.346487, longitude: 69.200353 },
    { latitude: 41.283981, longitude: 69.190498 },
    { latitude: 41.345707, longitude: 69.258437 },
    { latitude: 41.2167, longitude: 69.234462 },
    { latitude: 41.306153, longitude: 69.230226 },
    { latitude: 41.366430212706, longitude: 69.28692572371149 },
    { latitude: 41.325801773187706, longitude: 69.24601214495684 },
    { latitude: 41.27918793695472, longitude: 69.25096572015406 },
    { latitude: 41.31799268546646, longitude: 69.28521285629851 },
    { latitude: 41.31795145239723, longitude: 69.28531432691773 },
    { latitude: 41.31264413672044, longitude: 69.33258714722639 },
  ],
  activeOrders: [
    { latitude: 41.323092, longitude: 69.210653 },
    { latitude: 41.268688, longitude: 69.243819 },
    { latitude: 41.349996, longitude: 69.241642 },
    { latitude: 41.287689, longitude: 69.281748 },
    { latitude: 41.252283, longitude: 69.301829 },
    { latitude: 41.220786, longitude: 69.209114 },
    { latitude: 41.327977, longitude: 69.283774 },
    { latitude: 41.31383, longitude: 69.286821 },
    { latitude: 41.314398, longitude: 69.328611 },
    { latitude: 41.314177, longitude: 69.235758 },
    { latitude: 41.327132, longitude: 69.240072 },
    { latitude: 41.367012, longitude: 69.286148 },
    { latitude: 41.340268, longitude: 69.175288 },
    { latitude: 41.30277, longitude: 69.266293 },
    { latitude: 41.286583, longitude: 69.186644 },
    { latitude: 41.259353, longitude: 69.156788 },
    { latitude: 41.387181, longitude: 69.218785 },
    { latitude: 41.331332, longitude: 69.365362 },
    { latitude: 41.27479, longitude: 69.166357 },
    { latitude: 41.315048, longitude: 69.162576 },
    { latitude: 41.273824, longitude: 69.350385 },
    { latitude: 41.345361, longitude: 69.207129 },
    { latitude: 41.3635, longitude: 69.393207 },
  ],
};
